import { Injectable } from '@angular/core';

export interface SvgDraggable {
  getRect(): DOMRect;
  getIndex(): number;
  isDisabled(): boolean;
  setTranslate(dx: number, dy: number): void;
}

@Injectable()
export class SvgDragService {
  private items: SvgDraggable[] = [];

  register(item: SvgDraggable) {
    this.items.push(item);
  }

  unregister(item: SvgDraggable) {
    this.items = this.items.filter((x) => x !== item);
  }

  find(x: number, y: number): SvgDraggable | null {
    for (const item of this.items) {
      const box = item.getRect();
      if (!item.isDisabled() && box.x < x && x < box.x + box.width && box.y < y && y < box.y + box.height) {
        return item;
      }
    }
    return null;
  }

  private targets: SVGGraphicsElement[] = [];

  registerTarget(target: SVGGraphicsElement, index: number) {
    this.targets[index] = target;
  }

  findTargetIndex(item: SvgDraggable): number | null {
    const itemRect = item.getRect();
    const cx = itemRect.x + itemRect.width / 2;
    const cy = itemRect.y + itemRect.height / 2;
    for (let targetIndex = 0; targetIndex < this.targets.length; targetIndex++) {
      const targetRect = this.targets[targetIndex].getBoundingClientRect();
      if (targetRect.x < cx && cx < targetRect.x + targetRect.width && targetRect.y < cy && cy < targetRect.y + targetRect.height) {
        return targetIndex;
      }
    }
    return null;
  }
}
